import { Box, BoxProps } from '@mui/material';
import { PAGE_PADDING_X } from '../page/consts';

export function ContentBox({ sx, ...props }: BoxProps) {
  return <Box sx={{ px: PAGE_PADDING_X, ...sx }} {...props} />;
}
